module.exports = __webpack_public_path__ + "img/howtouse05.ff859695.jpg";